import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon, Dimmer, Loader, Message } from 'semantic-ui-react';
import moment from 'moment';

const RemoveScheduledPaymentModal = ({ open, onOpen, onClose, scheduledPayment, onDelete, actions }) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const _onDelete = useCallback(async () => {
		setLoading(true);
		try {
			await actions.removeScheduledPayment(scheduledPayment.referenceId, scheduledPayment.keyIdentifier, scheduledPayment.policyNumber, scheduledPayment.scheduledPaymentId);
			setLoading(false);
			onDelete();
		} catch (err) {
			setError(true);
			console.log(err);
			setLoading(false);
		}
	}, [actions, onDelete, scheduledPayment]);

	return (
		<Modal
			size='tiny'
			onOpen={onOpen}
			onClose={onClose}
			open={open}
			trigger={
				<span style={{ marginLeft: '10px', cursor: 'pointer' }}>
					<Icon link name='trash' /> Delete
				</span>
			}>
			<Modal.Header>Are you sure?</Modal.Header>
			<Modal.Content>
				{loading && (
					<Dimmer active inverted>
						<Loader active size='massive'>
							Deleting Scheduled Payment...
						</Loader>
					</Dimmer>
				)}
				{error && <Message error>Error deleting schedule payment</Message>}
				Delete scheduled payment for policy {scheduledPayment.policyNumber} on {moment(scheduledPayment.paymentScheduleDate).format('L')}?
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onClose}>No</Button>
				<Button primary onClick={_onDelete}>
					Yes
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

RemoveScheduledPaymentModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onOpen: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	actions: PropTypes.object.isRequired,
	schedulePayment: PropTypes.object.isRequired
};

export default RemoveScheduledPaymentModal;
